import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import { PaginatedSubPurchaseOrders } from "src/types";
import { PopulatedSubPurchaseOrder } from "src/types/database";

export interface GetSubPurchaseOrdersQueryParams {
  status?: string | string[];
  createdAtStart?: string;
  createdAtEnd?: string;
  region?: "UK" | "EU";
  sort?: string;
  limit?: number;
  pageToken?: string;
  searchTerm?: string;
}

class SubPurchaseOrderAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/sub-purchase-orders");
  }

  async getSubPurchaseOrders(queryParams: GetSubPurchaseOrdersQueryParams): Promise<PaginatedSubPurchaseOrders> {
    return await this.jwtRequest("GET", undefined, undefined, queryParams);
  }

  async getSubPurchaseOrderById(id: string): Promise<PopulatedSubPurchaseOrder> {
    return await this.jwtRequest("GET", `/${id}`);
  }
}

export { SubPurchaseOrderAPIService };
